import { render } from "./ImportFlowsSection.vue?vue&type=template&id=1284d400&scoped=true"
import script from "./ImportFlowsSection.vue?vue&type=script&lang=js"
export * from "./ImportFlowsSection.vue?vue&type=script&lang=js"

import "./ImportFlowsSection.vue?vue&type=style&index=0&id=1284d400&scoped=true&lang=scss"
import "./ImportFlowsSection.vue?vue&type=style&index=1&id=1284d400&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1284d400"]])

export default __exports__